module.exports = __webpack_public_path__ + "img/waterpolo-3.02c611a0.png";